// extracted by mini-css-extract-plugin
module.exports = {"studyGuideBannerLink":"StudyGuideBannerLink_studyGuideBannerLink__SVdfI","textContainer":"StudyGuideBannerLink_textContainer__GnZ6m","title":"StudyGuideBannerLink_title__7zE_k"};